import * as React from 'react';

import { GridMonthsProps } from '../../components/grid/months';
import GridMonth from '../../components/grid/month';

const GridMonthsView: React.StatelessComponent<GridMonthsProps> = props => {
    const monthToDisplay = props.monthsData.filter(m => m.monthMoment.format("YYYY-MM") === props.currentMoment.format("YYYY-MM"))[0];
    if (!monthToDisplay)
    {
        document.documentElement.setAttribute("data-calendar-loading", "true");
        return <></>
    }
    return (
        <section className="ace-cal-grid">
            <h2 className="visually-hidden">{props.text.gridViewHeading}</h2>
            <ul className="ace-cal-grid-months">
                {
                    <GridMonth key={`${monthToDisplay.monthMoment.month()}${monthToDisplay.monthMoment.year()}`} monthData={monthToDisplay} />
                }
            </ul>
        </section>
    )
}

export default GridMonthsView;